import { z } from 'zod';
import { policyTypeSchema } from './admin.js';
/* -------------------------------------------------------------------------- */
/* Policies people actually accept — Admin step 18, the other half            */
/*                                                                            */
/* An admin publishes a version; the console then reports how many accounts    */
/* have accepted it. That number can only be honest if there is somewhere for  */
/* a person to accept, which is what these contracts are for.                 */
/* -------------------------------------------------------------------------- */
/** A live policy version as the people bound by it see it. */
export const currentPolicySchema = z.object({
    id: z.string(),
    policyType: policyTypeSchema,
    version: z.string(),
    contentUrl: z.string(),
    effectiveDate: z.string(),
    /** When this account accepted this exact version, or null. */
    acceptedAt: z.string().nullable(),
});
export const currentPoliciesResponseSchema = z.object({
    items: z.array(currentPolicySchema),
    /**
     * Versions in effect that this account has not accepted. The count the UI
     * prompts on, so it does not have to re-derive the same filter.
     */
    outstanding: z.number().int().min(0),
});
//# sourceMappingURL=policies.js.map